import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import GoogleMap from 'google-map-react';
import classNames from 'classnames';
import {
	isUndefined, isEqual, map, isEmpty,
} from 'lodash';
import { bindActionCreators } from 'redux';
import constants from '@constants';
import { MapMarker } from '@components/common';
import Actions from '@redux/reports';
import ReportsTable from './reportsTable';
import {
	clientOverviewColumns, officerOverviewJobColumns, officerOverviewLocationColumns, officersColumns,
} from '../utils/columnsDefinition';

class LocationOverviewReport extends Component {
	constructor(props) {
		super(props);

		this.reportOverviewData = [];
	}

	shouldComponentUpdate = ({ reportData }) => {
		const lastProps = this.props;

		return (!isEqual(reportData, lastProps.reportData));
	}

	UNSAFE_componentWillReceiveProps = ({ reportData }) => {
		const lastProps = this.props;

		if (!isEqual(reportData, lastProps.reportData)) this.reportOverviewData = this.updateReportOverviewData(reportData);
	}

	componentWillUnmount = () => {
		const { resetReportsListData } = this.props;
		resetReportsListData();
	}

	updateReportOverviewData = (reportData) => [
		{
			empty                 : 'Scheduled',
			jobCount              : !isUndefined(reportData.ScheduledJobCount) ? reportData.ScheduledJobCount : 'N/A',
			totalHours            : !isUndefined(reportData.TotalScheduledHours) ? reportData.TotalScheduledHours : 'N/A',
			locationsCount        : !isUndefined(reportData.TotalLocationScheduledCount) ? reportData.TotalLocationScheduledCount : 'N/A',
			officersAssignedCount : !isUndefined(reportData.TotalOfficersScheduledCount) ? reportData.TotalOfficersScheduledCount : 'N/A',
		},
		{
			empty                 : 'Worked',
			jobCount              : !isUndefined(reportData.WorkedJobCount) ? reportData.WorkedJobCount : 'N/A',
			totalHours            : !isUndefined(reportData.TotalWorkedHours) ? reportData.TotalWorkedHours : 'N/A',
			locationsCount        : !isUndefined(reportData.TotalLocationWorkedCount) ? reportData.TotalLocationWorkedCount : 'N/A',
			officersAssignedCount : !isUndefined(reportData.TotalOfficersWorkedCount) ? reportData.TotalOfficersWorkedCount : 'N/A',
		},
	];

	verifyCoords = (center) => {
		const values = Object.values(center);
		const invalid = values.filter((coord) => Number.isNaN(coord) || typeof coord !== 'number').length;
		return invalid === 0;
	}

	render() {
		const { reportData, TimeZoneId } = this.props;
		const { GOOGLE_MAP_SETTINGS : { defaultCenter } } = constants;
		const center = {
			lat : parseFloat(reportData.LocationLatitude),
			lng : parseFloat(reportData.LocationLongitude),
		};
		return (
			<Fragment>
				<h3 className="font-size-24 font-regular color-gray-oxford">Location Overview Report</h3>
				<Row className="padding-top-20 hidden-print">
					<Col md={12}>
						<div className="panel-summary bg-white rate-stats-bottom-border">
							<Col md={3}>
								<h3 className="padding-left-15 font-size-24 font-regular color-gray-oxford">
									{ reportData.LocationName ? reportData.LocationName : 'Location Name' }
								</h3>
								<div className="list-element padding-15">
									<p className="color-gray-jungle-mist font-size-16 margin-top-5">
										<span className={classNames('display-block', { hidden : isEmpty(reportData.LocationStreetAddress1) })}>
											{ reportData.LocationStreetAddress1 }
										</span>
										<span className={classNames('display-inline', { hidden : isEmpty(reportData.LocationCity) })}>
											{ reportData.LocationCity }
											,
											{' '}
										</span>
										<span className={classNames('display-inline', { hidden : isEmpty(reportData.LocationState) })}>
											{ reportData.LocationState }
											{' '}
										</span>
										<span className={classNames('display-inline', { hidden : isEmpty(reportData.LocationZipcode) })}>
											{ reportData.LocationZipcode }
											{' '}
										</span>
									</p>
								</div>
							</Col>
							<Col md={9}>
								<div className="padding-15 height-250 width-490">
									<GoogleMap
										zoom={15}
										center={this.verifyCoords(center) === true ? center : defaultCenter}
										bootstrapURLKeys={{ key : constants.GOOGLE_MAP_SETTINGS.key }}
										options={constants.GOOGLE_MAP_OPTIONS}
									>
										<If condition={reportData.LocationLatitude && reportData.LocationLongitude}>
											<MapMarker
												lat={reportData.LocationLatitude}
												lng={reportData.LocationLongitude}
												type="job"
											/>
										</If>
									</GoogleMap>
								</div>
							</Col>
						</div>

						<ReportsTable
							data={this.reportOverviewData}
							tableColumn={clientOverviewColumns('locationOverview')}
						/>
					</Col>
				</Row>
				<ReportsTable
					header="Jobs"
					data={reportData.JobOverviewList || []}
					tableColumn={officerOverviewJobColumns(TimeZoneId)}
				/>
				<div className="text-right padding-right-10">
					<div className="color-gray-dove">Alerts: </div>
					{ map(constants.JOBS_ALERTS_LEGEND, (item, key) => (
						<Fragment key={`job_alert_legend_item_${key}`}>
							<span className="font-black color-gray-dove">
								{ key }
								{' '}
								=
								{' '}
							</span>
							<span className="color-gray-dove">{ `${item}${key !== 'O' ? ', ' : ''}` }</span>
						</Fragment>
					)) }
				</div>
				<ReportsTable
					header="Locations"
					data={reportData.LocationJobOverviewList || []}
					tableColumn={officerOverviewLocationColumns('Location')}
				/>
				<ReportsTable
					header="Officers"
					data={reportData.OfficerJobOverviewList || []}
					tableColumn={officersColumns}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	reports : {
		reportData,
	}, app: { user: { TimeZoneId } },
}) => ({
	reportData,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	resetReportsListData : bindActionCreators(Actions, dispatch).resetReportsListData,
});

LocationOverviewReport.propTypes = {
	TimeZoneId           : PropTypes.string,
	reportData           : PropTypes.object,
	resetReportsListData : PropTypes.func.isRequired,
};

LocationOverviewReport.defaultProps = {
	TimeZoneId : '',
	reportData : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationOverviewReport);
